/* 播放时间控制器 :
原子时钟
输入需要播放的时间 
缓存时间队列
输出应播放的时间
暂停、恢复、倍速。
开始时间
*/
export default class TimerCtrl {
  constructor(onOutput) {
    this.onOutput = onOutput;
    this.lastTime = 0;
    this.baseTime = performance.now();
    this.timeList = [];
    this.isPause = false;
    this.speed = 1;
    this.intervalTimer = null;
    this.isStop = false;
    this.offsetDelay = 0;
    this.offsetTime = 0;
    this.isRealTime = false;
    this.interval();
    this.onSpeedChange = (num) => {};
    this.isSpeedUp = false;
  }
  interval() {
    if (this.isStop) return;
    /* 判断现在时间是否符合输出时间 */
    let delay =
      (performance.now() - this.baseTime) * this.speed - this.offsetDelay;
    const data = this.timeList[0];
    if (this.isRealTime) {
      if (delay > 1000) {
        this.output();
      }
    }
    if (delay > 10000) {
      /* 跨段 */
      this.output();
    }
    if (this.isRealTime) {
      /* 实时需要保持少的缓存 */
      if (this.timeList.length > 60) {
        if (!this.isSpeedUp) {
          this.onSpeedChange(1.1);
        }
        this.isSpeedUp = true;
      } else if (this.timeList.length <= 10) {
        if (this.isSpeedUp) {
          this.onSpeedChange(1);
        }
        this.isSpeedUp = false;
      }
    }
    if (data && delay >= data.time - this.lastTime && !this.isPause) {
      // console.log("延迟delay", delay, this.offsetDelay, this.speed);
      this.output();
    }
    this.intervalTimer = setTimeout(() => {
      this.interval();
    }, 0);
  }

  /* 追加时间 */
  append(time, data) {
    if (this.lastTime === 0) {
      this.lastTime = time;
    }
    this.timeList.push({
      time,
      data,
    });
  }
  output() {
    try {
      const data = this.timeList.shift();
      if (data) {
        this.lastTime = data.time;
        this.baseTime = performance.now();
        this.onOutput(data);
      }
    } catch (err) {}
  }
  /* 偏移时间队列 */
  offset(time) {
    if (this.speed > 2) {
      return;
    }
    if (!time) return;

    this.offsetTime = parseInt(time);
    let isVideoFast = false;
    if (this.offsetTime > 0) {
      /* 视频慢了减少等待时间 */
      isVideoFast = false;
    } else {
      /* 视频快了增加等待时间 */
      isVideoFast = true;
    }
    if (Math.abs(this.offsetTime) > 2000) {
      /* 超过2s需要处理 */
      /* 严重不同步 */
      // console.log("严重不同步！", this.offsetTime);
      this.offsetDelay = isVideoFast ? +200 : -200;
      return;
    }
    if (Math.abs(this.offsetTime) > 1000) {
      /* 超过1s需要处理 */
      /* 稍微不同步 */
      // console.log("延迟", this.offsetTime);
      this.offsetDelay = isVideoFast ? +100 : -100;
      return;
    }
    if (Math.abs(this.offsetTime) > 200) {
      /* 超过200ms需要处理 */
      /* 稍微不同步 */
      // console.log("延迟", this.offsetTime);
      this.offsetDelay = isVideoFast ? +10 : -10;
      return;
    }
  }
  pause() {
    this.isPause = true;
    if (this.isRealTime) {
      clearTimeout(this.intervalTimer);
      this.timeList = [];
      this.lastTime = Infinity;
    }
  }
  resume() {
    this.isPause = false;
    if (this.isRealTime) {
      this.timeList = [];
      this.lastTime = Infinity;
      this.baseTime = performance.now();
      this.interval();
    }
  }
  changeSpeed(speed) {
    this.speed = speed;
  }
  stop() {
    // console.warn("stop");
    this.isStop = true;
    clearTimeout(this.intervalTimer);
  }
  getCacheSize() {
    return this.timeList.length;
  }
}
